var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    class: _vm.$style.container
  }, [_c('svg', {
    attrs: {
      "width": "20",
      "height": "8",
      "viewBox": "0 0 20 8",
      "fill": "none",
      "xmlns": "http://www.w3.org/2000/svg"
    }
  }, [_c('path', {
    attrs: {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      "d": "M10 0C13 0 15.9999 8 20 8H0C3.9749 8 7 0 10 0Z",
      "fill": "white"
    }
  })]), _vm._v(" " + _vm._s(_vm.message) + " ")]);
}
var staticRenderFns = []

export { render, staticRenderFns }